import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import './ShortDescription.scss';

const breakSentence = /\b(\w|\w+[^\w\s]*\w+)\b/g;

class ShortDescription extends Component {
  constructor(props) {
    super(props);
    const { text } = props;

    this.state = {
      text,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const text = event.target.value;
    this.setState({
      text,
    });
  }

  countWords() {
    const { text } = this.state;
    const wordsCount = text.match(breakSentence) || [];

    return wordsCount.length;
  }

  render() {
    const { text } = this.state;
    const wordsCount = this.countWords();
    const passedFifty = wordsCount > 50;

    const wordsText = passedFifty ? wordsCount : (50 - wordsCount);
    return (
      <div className="form-group mt-4">
        <label className="g-flex-fill" htmlFor="project_short_description">
          <span className="required">Please tell us about your project and product.</span>
          <a className="ms-2 small-text" data-bs-toggle="modal" data-bs-target="#exampleProjectModal">
            See example
          </a>
          <div className="small-text normal-font">
            The more detailed you are, the faster we can find you the perfect consultant!
          </div>
        </label>
        <TextareaAutosize
          className="form-control form-control--light"
          name="project[short_description]"
          id="project_short_description"
          rows={4}
          placeholder="We recommend a maximum of 50 words"
          onChange={this.handleChange}
          value={text}
          required="required"
        />
        <div className={`wordsContainer${passedFifty ? ' redish' : ''}`}>
          { wordsText }
          {' '}
          { wordsText === 1 ? 'word' : 'words' }
        </div>
      </div>
    );
  }
}

ShortDescription.propTypes = {
  text: PropTypes.string,
};

ShortDescription.defaultProps = {
  text: '',
};

export default ShortDescription;
